import { getEnumValues } from "@tecorien/mimic";

export enum AvailableFonts {
  Handsta = "Handsta",
  Arty = "Arty",
  Creattion = "Creattion",
  Holligate = "Holligate",
  MrsSaintDelafield = "MrsSaintDelafield",
  Southam = "Southam",
}
export const AvailableFontsArray = getEnumValues(AvailableFonts);
